import { render, staticRenderFns } from "./SymptomsTriggersDisplay.vue?vue&type=template&id=79c97d5a&scoped=true&"
import script from "./SymptomsTriggersDisplay.vue?vue&type=script&lang=ts&"
export * from "./SymptomsTriggersDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./SymptomsTriggersDisplay.vue?vue&type=style&index=0&id=79c97d5a&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c97d5a",
  null
  
)

export default component.exports